/* Reset collection branch context from primary navigation on every page. */
document.addEventListener('click', function (event) {
  if (event.defaultPrevented || event.button !== 0) return;
  var a = event.target.closest && event.target.closest('.tabs-wrapper a[data-bui-tab]');
  if (!a) return;
  try {
    var u = new URL(a.href, location.origin);
    if (u.origin !== location.origin || !u.pathname.startsWith('/collections/')) return;
    var key = u.pathname.replace(/\/$/, '') + (u.searchParams.get('view') ? '?view=' + encodeURIComponent(u.searchParams.get('view')) : '');
    var stored = JSON.parse(sessionStorage.getItem('bot.collection-pills.v2'));
    var entries = stored && Array.isArray(stored.entries) ? stored.entries.filter(function (e) { return e && e.key !== key; }).slice(-39) : [];
    entries.push({key:key,state:{reset:true,primary:a.getAttribute('href')}});
    sessionStorage.setItem('bot.collection-pills.v2', JSON.stringify({entries:entries}));
  } catch (_) {}
}, true);

/* ============================================================
   BoT App-UI Port v7 — home blocks + refractive elastic lenses for top tabs
   and .bottom-nav
   v7: content-adaptive dock contrast, editable clear-to-frosted glass,
   and Shopify section-reload support.
   v3: rect-based visible() (offsetParent is null on position:fixed
   bars, which blocked boot entirely in v2), live node collection,
   MutationObserver re-sync, delayed boot, inline dock hardening.
   ES5. No external deps.
   ============================================================ */
(function(){
  "use strict";
  if (window.__botAppUI) return; window.__botAppUI = true;

  function ready(fn){
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function(){

    /* ---- home blocks: weekday greeting, relocate Smart Analysis +
       AM/PM routes into the page flow, gold sub-kickers ---- */
    (function(){
      var greet = document.getElementById("buiGreet");
      if (greet){
        var days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        var gp = greet.getAttribute("data-prefix") || "Happy";
        var gs = greet.getAttribute("data-suffix") || "Beautiful.";
        greet.innerHTML = gp + " " + days[new Date().getDay()] + ",<br>" + gs;
      }
    })();

    /* ---- quick add: keep Shopify's native submit/variant engine, then use
       the freshly rendered bundled-section response to show the exact
       selected-variant quantity on the same successful CTA. ---- */
    (function initQuickAddCartCount(){
      if (!window.customElements || !window.customElements.whenDefined) return;

      window.customElements.whenDefined("quick-add-modal").then(function(){
        var modal = document.getElementById("quick-add-modal");
        if (!modal || modal.__buiCartCountReady || typeof modal.showAddedToCartView !== "function") return;

        modal.__buiCartCountReady = true;
        var nativeShowAddedToCartView = modal.showAddedToCartView;

        modal.showAddedToCartView = function(payload){
          var html = payload && payload.html;
          var input = this.querySelector('product-form [name="id"]');
          var button = this.querySelector("product-form .button-add-to-cart");
          var label = button && button.querySelector(":scope > span:not(.spinner)");
          var template = document.createElement("template");

          if (window.addedToCartNotification === "drawer" || !html || !input || !button || !label){
            return nativeShowAddedToCartView.call(this, payload);
          }

          template.innerHTML = html;
          var marker = template.content.querySelector("[data-bui-variant-cart-count]");
          var markerId = marker && marker.getAttribute("data-bui-variant-id");
          var selectedId = input.value;
          var count = marker ? parseInt(marker.getAttribute("data-bui-variant-cart-count"), 10) : 0;

          if (!markerId || String(markerId) !== String(selectedId) || !isFinite(count) || count < 1){
            return nativeShowAddedToCartView.call(this, payload);
          }

          label.textContent = "Added \u00b7 " + count + " in cart";
          button.setAttribute("data-bui-added", String(count));
          button.setAttribute("aria-label", "Add another. " + count + " currently in cart.");

          var status = this.querySelector("[data-bui-cart-status]");
          if (!status){
            status = document.createElement("span");
            status.className = "visually-hidden";
            status.setAttribute("role", "status");
            status.setAttribute("aria-live", "polite");
            status.setAttribute("data-bui-cart-status", "");
            button.parentNode.appendChild(status);
          }
          status.textContent = "";
          window.setTimeout(function(){
            status.textContent = count + (count === 1 ? " item" : " items") + " in cart.";
          }, 30);

          button.classList.remove("bui-cart-count-updated");
          void button.offsetWidth;
          button.classList.add("bui-cart-count-updated");
          window.setTimeout(function(){
            if (button && button.classList) button.classList.remove("bui-cart-count-updated");
          }, 420);

          return Promise.resolve();
        };

        modal.addEventListener("variant:change", function(){
          var status = modal.querySelector("[data-bui-cart-status]");
          if (status) status.textContent = "";
        });
      });
    })();

    /* Native dropdown-list moves mobile variant options into a temporary
       body-level x-modal. Mark that generated shell so it keeps the same
       glass language and receives an accessible close name. */
    (function initVariantListModals(){
      if (!window.MutationObserver) return;

      function enhance(scope){
        var modals = [];
        if (scope && scope.matches && scope.matches("x-modal.bottom-modal.modal-w-full")) modals.push(scope);
        if (scope && scope.querySelectorAll){
          modals = modals.concat(Array.prototype.slice.call(
            scope.querySelectorAll("x-modal.bottom-modal.modal-w-full")
          ));
        }
        for (var i = 0; i < modals.length; i++){
          if (!modals[i].querySelector(".dropdown-list")) continue;
          modals[i].classList.add("bui-variant-list-modal");
          var close = modals[i].querySelector("[data-button-close]");
          if (close){
            close.setAttribute("type", "button");
            if (!close.getAttribute("aria-label")) close.setAttribute("aria-label", "Close");
          }
        }
      }

      enhance(document);
      new MutationObserver(function(records){
        for (var i = 0; i < records.length; i++){
          for (var j = 0; j < records[i].addedNodes.length; j++) enhance(records[i].addedNodes[j]);
        }
      }).observe(document.body, { childList:true });
    })();

    /* ---- top category tabs: shared elastic refractive lens ---- */
    function initTabs(tabs){
      if (!tabs || tabs.__buiLensReady) return;
      tabs.__buiLensReady = true;

      var links = Array.prototype.slice.call(tabs.querySelectorAll("a[data-bui-tab]"));
      var topLens = tabs.querySelector(".bt-lens");
      if (!links.length || !topLens) return;

      var reduceTabs = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var centersTabs = [], widthsTabs = [];
      var xTabs = 0, widthTabs = 0, targetXTabs = 0, targetWidthTabs = 0;
      var velocityTabs = 0, widthVelocityTabs = 0, runningTabs = false, lastTabsTime = 0;
      var currentTabs = -1, pressedTabs = -1, startPointerX = 0, movedTabs = false;
      var suppressTabClick = false;
      var tabsEdgePending = false;
      var tabsContextKey = "bui-category-context-v1";

      /* ---- content-adaptive foreground for the clear top capsule ----
         Keep this sampler local to the tabs so the approved dock sampler
         below remains byte-identical. Five points + hysteresis prevent
         light/dark flashing while content boundaries pass underneath. */
      window.__buiTabsBar = tabs;
      var adaptiveTabs = false; // The storefront uses one light appearance.
      var tabsTone = "";
      var tabsContrastPending = false;
      var tabsSection = tabs.closest ? tabs.closest(".shopify-section") : tabs.parentElement;
      var tabsColorCanvas = document.createElement("canvas");
      tabsColorCanvas.width = tabsColorCanvas.height = 1;
      var tabsColorContext = tabsColorCanvas.getContext &&
        tabsColorCanvas.getContext("2d", { willReadFrequently: true });

      function activeTabs(){
        return window.__buiTabsBar === tabs &&
          (typeof tabs.isConnected === "undefined" || tabs.isConnected);
      }

      function updateTabsEdges(){
        if (!activeTabs()) return;
        var maxScroll = Math.max(0, tabs.scrollWidth - tabs.clientWidth);
        var position = Math.max(0, Math.min(maxScroll, tabs.scrollLeft));
        tabs.classList.toggle("bui-tabs-can-scroll-left", maxScroll > 2 && position > 2);
        tabs.classList.toggle("bui-tabs-can-scroll-right", maxScroll > 2 && position < maxScroll - 2);
        var selected = links[currentTabs];
        var selectedLeft = selected ? selected.getBoundingClientRect().left - tabs.getBoundingClientRect().left : -1;
        tabs.classList.toggle("bui-tabs-selection-at-start", selectedLeft >= 0 && selectedLeft <= 9);
      }

      function queueTabsEdges(immediate){
        if (!activeTabs()) return;
        if (immediate){ updateTabsEdges(); return; }
        if (tabsEdgePending) return;
        tabsEdgePending = true;
        requestAnimationFrame(function(){
          tabsEdgePending = false;
          updateTabsEdges();
        });
      }

      function parseTabsColor(value){
        if (!tabsColorContext || !value || value === "transparent") return null;
        try{
          tabsColorContext.clearRect(0, 0, 1, 1);
          tabsColorContext.fillStyle = "rgba(0,0,0,0)";
          tabsColorContext.fillStyle = value;
          tabsColorContext.fillRect(0, 0, 1, 1);
          var pixel = tabsColorContext.getImageData(0, 0, 1, 1).data;
          return { r:pixel[0], g:pixel[1], b:pixel[2], a:pixel[3] / 255 };
        }catch(e){ return null; }
      }

      function tabsTokenColor(value){
        if (!value) return null;
        value = value.trim();
        if (!value || value.indexOf("var(") !== -1) return null;
        if (/^(#|rgb|hsl|color\()/i.test(value)) return parseTabsColor(value);
        return parseTabsColor("rgb(" + value + ")");
      }

      function tabsLinearChannel(value){
        value /= 255;
        return value <= .04045 ? value / 12.92 : Math.pow((value + .055) / 1.055, 2.4);
      }

      function tabsLuminance(color){
        return .2126 * tabsLinearChannel(color.r) +
          .7152 * tabsLinearChannel(color.g) +
          .0722 * tabsLinearChannel(color.b);
      }

      function tabsGrayForLuminance(value){
        var channel = value <= .0031308
          ? value * 12.92
          : 1.055 * Math.pow(value, 1 / 2.4) - .055;
        return Math.max(0, Math.min(255, channel * 255));
      }

      function addTabsLayer(mix, color){
        if (!color || color.a <= .01 || mix.a >= .98) return;
        var alpha = Math.max(0, Math.min(1, color.a));
        var room = 1 - mix.a;
        mix.r += color.r * alpha * room;
        mix.g += color.g * alpha * room;
        mix.b += color.b * alpha * room;
        mix.a += alpha * room;
      }

      function authoredTabsSurfaceLuminance(el, style){
        var node = el;
        for (var depth = 0; node && depth < 7; depth++, node = node.parentElement){
          var explicit = node.getAttribute &&
            (node.getAttribute("data-bui-tabs-tone") || node.getAttribute("data-bui-dock-tone"));
          if (explicit === "dark") return .03;
          if (explicit === "light") return .96;

          var nodeStyle = depth === 0 ? style : window.getComputedStyle(node);
          var foreground = tabsTokenColor(nodeStyle.getPropertyValue("--color-foreground"));
          if (foreground && foreground.a > .8){
            var foregroundLuma = tabsLuminance(foreground);
            if (foregroundLuma > .68) return .07;
            if (foregroundLuma < .30) return .92;
          }

          var background = tabsTokenColor(nodeStyle.getPropertyValue("--color-background"));
          if (background && background.a > .8) return tabsLuminance(background);
        }
        return null;
      }

      function tabsSurfaceLuminanceAt(x, y){
        var stack = document.elementsFromPoint
          ? document.elementsFromPoint(x, y)
          : [document.elementFromPoint(x, y)];
        var mix = { r:0, g:0, b:0, a:0 };

        for (var i = 0; i < stack.length; i++){
          var el = stack[i];
          if (!el || el === tabs || tabs.contains(el) || el === tabsSection) continue;
          var style = window.getComputedStyle(el);
          if (style.visibility === "hidden" || style.display === "none") continue;

          var tag = el.tagName;
          var hasVisualMedia = tag === "IMG" || tag === "PICTURE" ||
            tag === "VIDEO" || tag === "CANVAS" ||
            (style.backgroundImage && style.backgroundImage !== "none");
          if (hasVisualMedia){
            var authoredLuma = authoredTabsSurfaceLuminance(el, style);
            if (authoredLuma !== null){
              var gray = tabsGrayForLuminance(authoredLuma);
              addTabsLayer(mix, { r:gray, g:gray, b:gray, a:1 });
              break;
            }
          }

          addTabsLayer(mix, parseTabsColor(style.backgroundColor));
          if (mix.a >= .98) break;
        }

        if (mix.a < 1){
          mix.r += 255 * (1 - mix.a);
          mix.g += 255 * (1 - mix.a);
          mix.b += 255 * (1 - mix.a);
        }
        return tabsLuminance({ r:mix.r, g:mix.g, b:mix.b });
      }

      function setTabsTone(nextTone){
        if (nextTone === tabsTone && tabs.classList.contains("bui-tabs-" + nextTone)) return;
        tabsTone = nextTone;
        tabs.classList.toggle("bui-tabs-dark", nextTone === "dark");
        tabs.classList.toggle("bui-tabs-light", nextTone === "light");
        tabs.setAttribute("data-bui-tone", nextTone);
      }

      function updateTabsContrast(){
        if (!activeTabs() || tabs.getBoundingClientRect().width <= 0) return;
        if (!adaptiveTabs){ setTabsTone("light"); return; }

        var rect = tabs.getBoundingClientRect();
        var y = Math.max(0, Math.min(window.innerHeight - 1, rect.top + rect.height / 2));
        var points = [.12, .31, .50, .69, .88];
        var samples = [];
        for (var i = 0; i < points.length; i++){
          samples.push(tabsSurfaceLuminanceAt(rect.left + rect.width * points[i], y));
        }
        samples.sort(function(a, b){ return a - b; });
        var median = samples[Math.floor(samples.length / 2)];

        if (tabsTone === "dark"){
          if (median > .36) setTabsTone("light");
        } else if (median < .26){
          setTabsTone("dark");
        }
      }

      function queueTabsContrast(immediate){
        if (!activeTabs()) return;
        if (!adaptiveTabs){ setTabsTone("light"); return; }
        if (immediate){ updateTabsContrast(); return; }
        if (tabsContrastPending) return;
        tabsContrastPending = true;
        setTimeout(function(){
          requestAnimationFrame(function(){
            tabsContrastPending = false;
            updateTabsContrast();
          });
        }, 76);
      }

      setTabsTone("light");
      updateTabsContrast();

      function measureTabs(){
        centersTabs = [];
        widthsTabs = [];
        for (var i = 0; i < links.length; i++){
          var r = links[i].getBoundingClientRect();
          var left = links[i].offsetLeft;
          centersTabs.push(left + r.width / 2);
          widthsTabs.push(Math.max(56, r.width + 6));
        }
      }

      function markTabs(idx){
        links.forEach(function(link,i){
          var selected=i===idx;
          link.classList.toggle('bt-active',selected);link.classList.remove('bot-tab-current');
          if(selected)link.setAttribute('aria-current','page');
          else {link.removeAttribute('aria-current');link.removeAttribute('data-bot-context-active');}
        });
      }

      function tabPath(link){
        try{
          var target = new URL(link.href, location.origin);
          if (target.origin !== location.origin) return "";
          return (target.pathname.replace(/\/$/, "") || "/") + (target.searchParams.get("view") ? "?view=" + encodeURIComponent(target.searchParams.get("view")) : "");
        }catch(e){ return ""; }
      }

      function rememberTabs(idx){
        if (idx < 0 || idx >= links.length) return;
        var path = tabPath(links[idx]);
        if (!path) return;
        try{ sessionStorage.setItem(tabsContextKey, path); }catch(e){}
      }

      function renderTabs(){
        var energy = Math.min(1, (Math.abs(velocityTabs) + Math.abs(widthVelocityTabs) * 1.7) / 760);
        var stretch = 1 + energy * .10;
        topLens.style.setProperty("--bui-tabs-energy", energy.toFixed(3));
        topLens.style.width = Math.max(1, widthTabs) + "px";
        topLens.style.transform = "translate3d(" + (xTabs - widthTabs / 2) + "px,0,0) scale(" + stretch.toFixed(3) + "," + (1 - (stretch - 1) * .34).toFixed(3) + ")";
      }

      function stepTabs(t){
        if (!runningTabs) return;
        if (!lastTabsTime) lastTabsTime = t;
        var dt = Math.min(.032, (t - lastTabsTime) / 1000); lastTabsTime = t;
        var ax = 610 * (targetXTabs - xTabs) - 43 * velocityTabs;
        var aw = 540 * (targetWidthTabs - widthTabs) - 41 * widthVelocityTabs;
        velocityTabs += ax * dt; xTabs += velocityTabs * dt;
        widthVelocityTabs += aw * dt; widthTabs += widthVelocityTabs * dt;
        renderTabs();
        if (Math.abs(velocityTabs) < .025 && Math.abs(targetXTabs - xTabs) < .1 &&
            Math.abs(widthVelocityTabs) < .025 && Math.abs(targetWidthTabs - widthTabs) < .1){
          xTabs = targetXTabs; widthTabs = targetWidthTabs;
          velocityTabs = 0; widthVelocityTabs = 0; renderTabs();
          runningTabs = false; lastTabsTime = 0; topLens.style.willChange = "auto";
          return;
        }
        requestAnimationFrame(stepTabs);
      }

      function runTabs(){
        if (!runningTabs){
          runningTabs = true; lastTabsTime = 0; topLens.style.willChange = "transform,width";
          requestAnimationFrame(stepTabs);
        }
      }

      function selectTabs(idx, instant){
        if (idx < 0 || idx >= links.length){
          currentTabs = -1;
          runningTabs = false;
          lastTabsTime = 0;
          velocityTabs = 0;
          widthVelocityTabs = 0;
          markTabs(-1);
          topLens.hidden = true;
          topLens.style.willChange = "auto";
          return;
        }
        topLens.hidden = false;
        measureTabs();
        targetXTabs = centersTabs[idx];
        targetWidthTabs = widthsTabs[idx];
        topLens.style.top = links[idx].offsetTop + "px";
        topLens.style.height = links[idx].getBoundingClientRect().height + "px";
        markTabs(idx);
        if (instant || reduceTabs){
          xTabs = targetXTabs; widthTabs = targetWidthTabs;
          velocityTabs = 0; widthVelocityTabs = 0; renderTabs();
        } else runTabs();
      }

      function primaryHasNoSelection(){
        var path=location.pathname.replace(/\/$/,'')||'/';
        return path==='/'||(path==='/collections'&&new URL(location.href).searchParams.get('view')==='native-exclusive');
      }
      function initialTabs(){
        if(primaryHasNoSelection()){
          links.forEach(function(link){link.removeAttribute('aria-current');link.removeAttribute('data-bot-context-active');});
          return -1;
        }
        for (var i = 0; i < links.length; i++){
          if (links[i].hasAttribute("data-bot-context-active")){
            rememberTabs(i);
            return i;
          }
        }
        // Resolve navigation for this destination synchronously. The child
        // controller may still be fetching authored concerns; a generic last
        // category must not briefly win over this route's saved ancestry.
        var currentRoute=tabPath({href:location.href});
        for(var direct=0;direct<links.length;direct++){
          if(tabPath(links[direct])===currentRoute){rememberTabs(direct);return direct;}
        }
        try{
          var branchStore=JSON.parse(sessionStorage.getItem('bot.collection-pills.v2'));
          var branchEntries=branchStore&&Array.isArray(branchStore.entries)?branchStore.entries:[];
          var savedBranch=branchEntries.find(function(entry){return entry&&entry.key===currentRoute&&entry.state&&typeof entry.state.primary==='string';});
          if(savedBranch){
            var primaryRoute=tabPath({href:savedBranch.state.primary});
            for(var branch=0;branch<links.length;branch++){
              if(primaryRoute&&tabPath(links[branch])===primaryRoute){rememberTabs(branch);return branch;}
            }
          }
        }catch(e){}
        for (var i = 0; i < links.length; i++){
          if (links[i].hasAttribute("aria-current")){
            rememberTabs(i);
            return i;
          }
        }
        try{
          for (var j = 0; j < links.length; j++){
            var u = new URL(links[j].href, location.origin);
            if (tabPath(links[j]) === tabPath({href:location.href})){
              rememberTabs(j);
              return j;
            }
          }
        }catch(e){}
        /* The homepage is not a category page. Never restore a stale category
           lens there; keep stored context for product and other detail pages. */
        if ((location.pathname.replace(/\/$/, "") || "/") === "/") return -1;
        try{
          var storedPath = sessionStorage.getItem(tabsContextKey);
          if (storedPath){
            for (var k = 0; k < links.length; k++){
              if (tabPath(links[k]) === storedPath) return k;
            }
          }
        }catch(e){}
        return -1;
      }

      // One primary-rail owner: selection changes align to the optical 8px edge.
      // Re-align after a width change; height-only toolbar/keyboard changes
      // preserve the customer's manual horizontal browsing position.
      var alignedPrimaryKey=null;
      function alignPrimary(force){
        var target=links[currentTabs]||(primaryHasNoSelection()?links[0]:null);
        if(!target)return;
        var selectedKey=tabPath(target);
        if(!force&&alignedPrimaryKey===selectedKey)return;
        alignedPrimaryKey=selectedKey;
        var left=target.getBoundingClientRect().left-tabs.getBoundingClientRect().left+tabs.scrollLeft-8;
        var maxScroll=Math.max(0,tabs.scrollWidth-tabs.clientWidth);
        tabs.scrollTo({left:Math.max(0,Math.min(maxScroll,left)),behavior:'auto'});
      }
      window.addEventListener('pageshow',function(){currentTabs=initialTabs();selectTabs(currentTabs,true);alignPrimary(true);});
      links.forEach(function(link, idx){
        link.addEventListener("pointerdown", function(e){
          pressedTabs = idx; startPointerX = e.clientX; movedTabs = false;
          // A horizontal browse must not change the committed category.
        });
        link.addEventListener("pointermove", function(e){
          if (pressedTabs === idx && Math.abs(e.clientX - startPointerX) > 8) movedTabs = true;
        });
        link.addEventListener("pointerup", function(){
          if (pressedTabs !== idx) return;
          suppressTabClick = movedTabs;
          if (movedTabs) selectTabs(currentTabs, false);
          pressedTabs = -1;
        });
        link.addEventListener("pointercancel", function(){
          pressedTabs = -1; suppressTabClick = false; selectTabs(currentTabs, false);
        });
        link.addEventListener("click", function(e){
          if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
          if (suppressTabClick){
            suppressTabClick = false;
            e.preventDefault();
            e.stopPropagation();
            selectTabs(currentTabs, false);
            return;
          }
          // Keep the departing page intact for the browser's Back snapshot.
          // The destination commits its own selection and alignment on load.
          rememberTabs(idx);
        });
      });

      document.addEventListener('bot:collection-context', function(event){
        if (!tabs.isConnected) return;
        var primary=event.detail&&event.detail.primary;
        var resolved=typeof primary==='string'?links.findIndex(function(link){return tabPath(link)===tabPath({href:primary});}):-1;
        currentTabs=primaryHasNoSelection()?-1:resolved>=0?resolved:initialTabs();
        selectTabs(currentTabs,true);alignPrimary(false);
      });
      currentTabs = initialTabs();
      selectTabs(currentTabs, true);
      alignPrimary(false);
      queueTabsEdges(true);
      try{
        tabs.addEventListener("scroll", function(){ queueTabsEdges(false); }, { passive:true });
      }catch(e){
        tabs.addEventListener("scroll", function(){ queueTabsEdges(false); });
      }
      var primaryWidth = tabs.clientWidth;
      var primaryResizeFrame = null;
      window.addEventListener("resize", function(){
        if (primaryResizeFrame !== null) cancelAnimationFrame(primaryResizeFrame);
        primaryResizeFrame = requestAnimationFrame(function(){
          primaryResizeFrame = null;
          if (!tabs.isConnected) return;
          var width = tabs.clientWidth;
          if (width > 0 && width !== primaryWidth) alignPrimary(true);
          primaryWidth = width;
          selectTabs(currentTabs, true);
          queueTabsEdges(false);
          queueTabsContrast(false);
        });
      });

      function onTabsSurfaceChange(){ queueTabsContrast(false); }
      try{
        document.addEventListener("scroll", onTabsSurfaceChange, { passive:true, capture:true });
      }catch(e){
        document.addEventListener("scroll", onTabsSurfaceChange, true);
      }
      window.addEventListener("orientationchange", onTabsSurfaceChange);
      document.addEventListener("load", function(e){
        var tag = e.target && e.target.tagName;
        if (tag === "IMG" || tag === "VIDEO"){
          queueTabsEdges(false);
          queueTabsContrast(false);
        }
      }, true);
    }

    initTabs(document.querySelector(".tabs-wrapper"));

    /* ---- persistent navigation stack ----
       The primary rail remains visible across storefront routes. Contextual
       rails join the stack only when that page renders real links. */
    function initScrollRails(){
      if (window.__buiRailController){
        window.__buiRailController.refresh();
        return;
      }

      var root = document.documentElement;
      var tabsSection = null;
      var guideSection = null;
      var chipsSection = null;
      var tabs = null;
      var guide = null;
      var chips = null;
      var observed = [];
      var resizeObserver = window.ResizeObserver ? new ResizeObserver(queueMeasure) : null;
      var measurePending = false;
      var scrollPending = false;

      function firstFilled(selector, itemSelector){
        var nodes = document.querySelectorAll(selector);
        for (var i = 0; i < nodes.length; i++){
          if (nodes[i].querySelector(itemSelector)) return nodes[i];
        }
        return null;
      }

      function outerHeight(node){
        if (!node) return 0;
        var style = window.getComputedStyle(node);
        return Math.ceil(node.getBoundingClientRect().height +
          (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0));
      }

      function measure(){
        measurePending = false;
        root.style.setProperty("--bui-tabs-stack-h",
          outerHeight(tabsSection && tabsSection.classList.contains("bui-tabs-sticky-section") ? tabs : null) + "px");
        root.style.setProperty("--bui-guidance-stack-h",
          outerHeight(guideSection && guideSection.classList.contains("bui-guidance-sticky-section") ? guide : null) + "px");
      }

      function queueMeasure(){
        if (measurePending) return;
        measurePending = true;
        requestAnimationFrame(measure);
      }

      function exactPath(link){
        try{
          var rawHref = link.getAttribute("href");
          if (!rawHref || rawHref === "#") return false;
          var target = new URL(rawHref, window.location.origin);
          var targetPath = target.pathname.replace(/\/$/, "") || "/";
          var currentPath = window.location.pathname.replace(/\/$/, "") || "/";
          var targetView=target.searchParams.get('view')||'';
          var currentView=new URL(window.location.href).searchParams.get('view')||'';
          return target.origin === window.location.origin && targetPath === currentPath && targetView===currentView;
        }catch(e){ return false; }
      }

      function stickyEnabled(node){
        return !!node && node.getAttribute("data-bui-sticky") !== "false";
      }

      function markAndCenter(container, selector){
        if (!container) return;
        var links = container.querySelectorAll(selector);
        var active = null;
        for (var i = 0; i < links.length; i++){
          if (!active && exactPath(links[i])){
            links[i].setAttribute("aria-current", "page");
            active = links[i];
          }
        }
        // Child-rail scrolling is owned by bot-collection-pills. This pass
        // marks exact destinations only and must not recenter after hydration.
      }

      function refresh(){
        // Keep stable sticky ancestors in place during context/section refresh.
        // Tearing every class down and rebuilding it restarts sticky layout.
        if(resizeObserver)resizeObserver.disconnect();
        var previousObserved=observed;observed=[];
        tabs = document.querySelector(".tabs-wrapper");
        guide = firstFilled(
          'body.collection-page [data-bot-featured-links], body.product-page [data-bot-featured-links]',
          ".guidance-item"
        );
        chips = firstFilled(
          'body.collection-page [data-bot-quick-links], body.product-page [data-bot-quick-links]',
          ".category-item"
        );
        tabsSection = tabs && tabs.closest ? tabs.closest(".shopify-section") : null;
        guideSection = guide && guide.closest ? guide.closest(".shopify-section") : null;
        chipsSection = chips && chips.closest
          ? (chips.closest(".shopify-section") || chips.closest(".bot-quick-links-sticky-shell"))
          : null;

        if (chipsSection && chipsSection.classList.contains("shopify-section")){
          var contextBreadcrumb = chipsSection.querySelector("[data-bot-context-breadcrumb]");
          if (contextBreadcrumb && chipsSection.parentNode &&
              !(window.Shopify && window.Shopify.designMode)){
            chipsSection.parentNode.insertBefore(contextBreadcrumb, chipsSection.nextSibling);
          }
        }

        if (tabsSection && stickyEnabled(tabs)){ tabsSection.classList.add("bui-tabs-sticky-section"); observed.push(tabsSection); }
        if (guideSection && stickyEnabled(guide)){ guideSection.classList.add("bui-guidance-sticky-section"); observed.push(guideSection); }
        if (chipsSection && stickyEnabled(chips)){ chipsSection.classList.add("bui-chips-sticky-section"); observed.push(chipsSection); }

        previousObserved.forEach(function(node){if(!observed.includes(node))node.classList.remove('bui-tabs-sticky-section','bui-guidance-sticky-section','bui-chips-sticky-section');});
        if (resizeObserver){
          if (tabsSection && tabsSection.classList.contains("bui-tabs-sticky-section")) resizeObserver.observe(tabs);
          if (guideSection && guideSection.classList.contains("bui-guidance-sticky-section")) resizeObserver.observe(guide);
        }
        requestAnimationFrame(function(){
          markAndCenter(guide, ".guidance-item");
          if (chipsSection) chipsSection.querySelectorAll('[data-bot-quick-links]').forEach(function(rail){
            markAndCenter(rail, ".category-item");
          });
          measure();
        });
      }

      function railHasFocus(){
        var active = document.activeElement;
        return !!(active && (
          (tabsSection && tabsSection.contains(active)) ||
          (guideSection && guideSection.contains(active)) ||
          (chipsSection && chipsSection.contains(active))
        ));
      }

      function revealRails(){
        root.classList.remove("bui-nav-scrolling-down");
      }

      function settleRails(){
        revealRails();
      }

      function processScroll(){
        scrollPending = false;
        revealRails();
      }

      function onScroll(){
        if (scrollPending) return;
        scrollPending = true;
        requestAnimationFrame(processScroll);
      }

      function onFocusChange(){
        if (railHasFocus()) revealRails();
      }

      try{
        window.addEventListener("scroll", onScroll, { passive:true });
      }catch(e){
        window.addEventListener("scroll", onScroll);
      }
      if ("onscrollend" in window) window.addEventListener("scrollend", settleRails);
      window.addEventListener("resize", queueMeasure);
      window.addEventListener("orientationchange", queueMeasure);
      document.addEventListener("focusin", onFocusChange);
      document.addEventListener("focusout", function(){ window.setTimeout(onFocusChange, 0); });

      window.__buiRailController = { refresh:refresh };
      refresh();
    }

    // The compact native stack has one scroll owner. Suspend the legacy
    // custom-element hide/reveal listener, including its delayed observer
    // registration; restore its normal desktop behavior above the tablet band.
    function coordinateStickyHeader(){
      document.querySelectorAll('sticky-header').forEach(function(header){
        if(header.__nativeStickyConfigured||!header.onScrollHandler||!header.addScrollListener)return;
        header.__nativeStickyConfigured=true;
        var compact=window.matchMedia('not all and (min-width:1151px)'),originalAdd=header.addScrollListener,originalHide=header.hide,originalReveal=header.reveal;
        header.hide=function(){if(!compact.matches&&originalHide)return originalHide.apply(header,arguments);};
        header.reveal=function(){if(!compact.matches&&originalReveal)return originalReveal.apply(header,arguments);};
        header.addScrollListener=function(){if(!compact.matches&&header.isConnected)originalAdd.call(header);};
        function apply(){
          window.removeEventListener('scroll',header.onScrollHandler,false);
          if(compact.matches){
            if(header.section)header.section.classList.remove('section-site-header--hidden','section-site-header--sticky','animate');
            document.documentElement.style.removeProperty('--header-height-sticky');
          }else if(!header.disabled&&header.isConnected){originalAdd.call(header);header.onScroll();}
        }
        function cleanup(event){if(event.target&&event.target.contains(header)){window.removeEventListener('scroll',header.onScrollHandler,false);compact.removeEventListener('change',apply);document.removeEventListener('shopify:section:unload',cleanup);}}
        document.addEventListener('shopify:section:unload',cleanup);
        compact.addEventListener('change',apply);apply();
      });
    }
    if(window.customElements)customElements.whenDefined('sticky-header').then(coordinateStickyHeader);
    document.addEventListener('shopify:section:load',coordinateStickyHeader);
    initScrollRails();

    function initDock(bar){
    if (bar && bar.dataset.nativeDock === "true") return;
    if (!bar || bar.__buiDockReady) return;
    bar.__buiDockReady = true;
    window.__buiDockBar = bar;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ---- LIVE item collection: re-query every time ---- */
    function getItems(){
      var out = [];
      for (var i = 0; i < bar.children.length; i++){
        var c = bar.children[i];
        if (c.tagName === "A" || c.tagName === "BUTTON") out.push(c);
      }
      return out;
    }

    /* wrap stray text nodes so labels can fade in min state */
    function wrapLabels(){
      getItems().forEach(function(el){
        for (var n = el.childNodes.length - 1; n >= 0; n--){
          var nd = el.childNodes[n];
          if (nd.nodeType === 3 && nd.textContent.replace(/\s+/g, "")){
            var sp = document.createElement("span");
            sp.className = "bn-lb";
            sp.textContent = nd.textContent.trim();
            el.replaceChild(sp, nd);
          } else if (nd.nodeType === 1 && nd.tagName === "SPAN" && !nd.classList.contains("bn-avatar")){
            nd.classList.add("bn-lb");
          }
        }
      });
    }

    /* inject lens */
    var lens = document.createElement("div");
    lens.className = "bn-lens";
    bar.insertBefore(lens, bar.firstChild);

    /* geometry — items + centers refreshed together */
    var items = [], centers = [], barLeft = 0, barW = 0, lensW = 60;
    function visible(){
      var r = bar.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }
    function measure(){
      if (!visible()) return;
      items = getItems();
      var br = bar.getBoundingClientRect();
      barLeft = br.left; barW = br.width;
      centers = items.map(function(el){
        var r = el.getBoundingClientRect();
        return r.left - br.left + r.width / 2;
      });
      if (items.length){
        lensW = Math.max(54, Math.min(76, (items[0].getBoundingClientRect().width || 60) + 6));
        lens.style.width = lensW + "px";
      }
    }

    /* ---- content-adaptive foreground for the clear dock ----
       Five points are sampled behind the capsule. Explicit surfaces win;
       image sections fall back to the theme's authored foreground/background
       colours. Median luminance + hysteresis prevents flashing at boundaries. */
    var adaptiveContrast = false; // Keep light dock ink over every page surface.
    var dockTone = "";
    var contrastPending = false;
    var colorCanvas = document.createElement("canvas");
    colorCanvas.width = colorCanvas.height = 1;
    var colorContext = colorCanvas.getContext && colorCanvas.getContext("2d", { willReadFrequently: true });

    function activeDock(){
      return window.__buiDockBar === bar &&
        (typeof bar.isConnected === "undefined" || bar.isConnected);
    }

    function parseColor(value){
      if (!colorContext || !value || value === "transparent") return null;
      try{
        colorContext.clearRect(0, 0, 1, 1);
        colorContext.fillStyle = "rgba(0,0,0,0)";
        colorContext.fillStyle = value;
        colorContext.fillRect(0, 0, 1, 1);
        var p = colorContext.getImageData(0, 0, 1, 1).data;
        return { r:p[0], g:p[1], b:p[2], a:p[3] / 255 };
      }catch(e){ return null; }
    }

    function tokenColor(value){
      if (!value) return null;
      value = value.trim();
      if (!value || value.indexOf("var(") !== -1) return null;
      if (/^(#|rgb|hsl|color\()/i.test(value)) return parseColor(value);
      return parseColor("rgb(" + value + ")");
    }

    function linearChannel(value){
      value /= 255;
      return value <= .04045 ? value / 12.92 : Math.pow((value + .055) / 1.055, 2.4);
    }

    function luminance(color){
      return .2126 * linearChannel(color.r) +
        .7152 * linearChannel(color.g) +
        .0722 * linearChannel(color.b);
    }

    function grayForLuminance(value){
      var channel = value <= .0031308
        ? value * 12.92
        : 1.055 * Math.pow(value, 1 / 2.4) - .055;
      return Math.max(0, Math.min(255, channel * 255));
    }

    function addLayer(mix, color){
      if (!color || color.a <= .01 || mix.a >= .98) return;
      var alpha = Math.max(0, Math.min(1, color.a));
      var room = 1 - mix.a;
      mix.r += color.r * alpha * room;
      mix.g += color.g * alpha * room;
      mix.b += color.b * alpha * room;
      mix.a += alpha * room;
    }

    function authoredSurfaceLuminance(el, style){
      var node = el;
      for (var depth = 0; node && depth < 7; depth++, node = node.parentElement){
        var explicit = node.getAttribute && node.getAttribute("data-bui-dock-tone");
        if (explicit === "dark") return .03;
        if (explicit === "light") return .96;

        var nodeStyle = depth === 0 ? style : window.getComputedStyle(node);
        var foreground = tokenColor(nodeStyle.getPropertyValue("--color-foreground"));
        if (foreground && foreground.a > .8){
          var foregroundLuma = luminance(foreground);
          if (foregroundLuma > .68) return .07;
          if (foregroundLuma < .30) return .92;
        }

        var background = tokenColor(nodeStyle.getPropertyValue("--color-background"));
        if (background && background.a > .8) return luminance(background);
      }
      return null;
    }

    function surfaceLuminanceAt(x, y){
      var stack = document.elementsFromPoint
        ? document.elementsFromPoint(x, y)
        : [document.elementFromPoint(x, y)];
      var mix = { r:0, g:0, b:0, a:0 };

      for (var i = 0; i < stack.length; i++){
        var el = stack[i];
        if (!el || el === bar || bar.contains(el)) continue;
        var style = window.getComputedStyle(el);
        if (style.visibility === "hidden" || style.display === "none") continue;

        var tag = el.tagName;
        var hasVisualMedia = tag === "IMG" || tag === "PICTURE" ||
          tag === "VIDEO" || tag === "CANVAS" ||
          (style.backgroundImage && style.backgroundImage !== "none");
        if (hasVisualMedia){
          var authoredLuma = authoredSurfaceLuminance(el, style);
          if (authoredLuma !== null){
            var gray = grayForLuminance(authoredLuma);
            addLayer(mix, { r:gray, g:gray, b:gray, a:1 });
            break;
          }
        }

        addLayer(mix, parseColor(style.backgroundColor));
        if (mix.a >= .98) break;
      }

      if (mix.a < 1){
        mix.r += 255 * (1 - mix.a);
        mix.g += 255 * (1 - mix.a);
        mix.b += 255 * (1 - mix.a);
      }
      return luminance({ r:mix.r, g:mix.g, b:mix.b });
    }

    function setDockTone(nextTone){
      if (nextTone === dockTone && bar.classList.contains("bui-dock-" + nextTone)) return;
      dockTone = nextTone;
      bar.classList.toggle("bui-dock-dark", nextTone === "dark");
      bar.classList.toggle("bui-dock-light", nextTone === "light");
      bar.setAttribute("data-bui-tone", nextTone);
    }

    function updateDockContrast(){
      if (!activeDock() || !visible()) return;
      if (!adaptiveContrast){ setDockTone("light"); return; }

      var rect = bar.getBoundingClientRect();
      var y = Math.max(0, Math.min(window.innerHeight - 1, rect.top + 31));
      var points = [.12, .31, .50, .69, .88];
      var samples = [];
      for (var i = 0; i < points.length; i++){
        samples.push(surfaceLuminanceAt(rect.left + rect.width * points[i], y));
      }
      samples.sort(function(a, b){ return a - b; });
      var median = samples[Math.floor(samples.length / 2)];

      if (dockTone === "dark"){
        if (median > .36) setDockTone("light");
      } else if (median < .26){
        setDockTone("dark");
      }
    }

    function queueDockContrast(immediate){
      if (!activeDock()) return;
      if (!adaptiveContrast){ setDockTone("light"); return; }
      if (immediate){ updateDockContrast(); return; }
      if (contrastPending) return;
      contrastPending = true;
      setTimeout(function(){
        requestAnimationFrame(function(){
          contrastPending = false;
          updateDockContrast();
        });
      }, 76);
    }

    setDockTone("light");
    updateDockContrast();

    function nearestIdx(x){
      var best = 0, bd = 1e9;
      for (var i = 0; i < centers.length; i++){
        var d = Math.abs(centers[i] - x);
        if (d < bd){ bd = d; best = i; }
      }
      return best;
    }

    /* spring state */
    var X = 0, V = 0, TX = 0, mode = "snap", running = false, lastT = 0;
    var dragging = false, dragMoved = false, curIdx = 0, lastNear = -1;
    var K_SNAP = 560, C_SNAP = 38, K_FOLLOW = 840, C_FOLLOW = 54;

    function render(){
      var energy = Math.min(1, Math.abs(V) / 760);
      var sx = 1 + energy * .115 + (dragging && dragMoved ? .025 : 0);
      var sy = Math.max(.945, 1 - (sx - 1) * .38);
      lens.style.setProperty("--bui-lens-energy", energy.toFixed(3));
      lens.style.transform = "translateX(" + (X - lensW / 2) + "px) scale(" + sx.toFixed(3) + "," + sy.toFixed(3) + ")";
      if (!reduce){
        for (var i = 0; i < items.length; i++){
          var d = centers[i] - X;
          var g = Math.exp(-(d * d) / 3872);
          items[i].style.transform = "translateY(" + (-1.2 * g).toFixed(2) + "px) scale(" + (1 + .035 * g).toFixed(3) + ")";
        }
      }
      var n = nearestIdx(X);
      if (n !== lastNear){
        for (var j = 0; j < items.length; j++) items[j].classList.toggle("bn-active", j === n);
        lastNear = n;
      }
    }

    function step(t){
      if (!lastT) lastT = t;
      var dt = Math.min(.032, (t - lastT) / 1000); lastT = t;
      var k = mode === "snap" ? K_SNAP : K_FOLLOW;
      var c = mode === "snap" ? C_SNAP : C_FOLLOW;
      var a = k * (TX - X) - c * V;
      V += a * dt; X += V * dt;
      render();
      if (!dragging && Math.abs(V) < .02 && Math.abs(TX - X) < .1){
        X = TX; V = 0; render(); running = false; lastT = 0;
        lens.style.willChange = "auto";
        return;
      }
      requestAnimationFrame(step);
    }
    function run(){
      if (!running){
        running = true; lastT = 0;
        lens.style.willChange = "transform";
        requestAnimationFrame(step);
      }
    }

    function snapTo(idx, instant){
      curIdx = idx; TX = centers[idx] || 0; mode = "snap";
      if (instant || reduce){ X = TX; V = 0; render(); }
      else run();
    }

    /* unified tap + drag: release commits nearest LIVE item */
    var allowClick = false, suppressNext = false;
    bar.addEventListener("click", function(e){
      if (allowClick) return;
      if (suppressNext){
        suppressNext = false;
        e.preventDefault(); e.stopPropagation();
      }
    }, true);

    function commit(idx){
      snapTo(idx);
      var el = items[idx];
      if (!el || !el.isConnected){ measure(); el = items[idx]; }
      if (!el) return;
      allowClick = true;
      try{ el.click(); } finally { allowClick = false; }
    }

    bar.addEventListener("pointerdown", function(e){
      if (!visible()) return;
      measure();
      dragging = true; dragMoved = false;
      mode = "follow";
      TX = Math.max(lensW/2, Math.min(barW - lensW/2, e.clientX - barLeft));
      try{ bar.setPointerCapture(e.pointerId); }catch(err){}
      e.preventDefault();
      run();
    });
    bar.addEventListener("pointermove", function(e){
      if (!dragging) return;
      var x = Math.max(lensW/2, Math.min(barW - lensW/2, e.clientX - barLeft));
      if (Math.abs(x - TX) > 3) dragMoved = true;
      TX = x; run();
    });
    function endDrag(e, cancel){
      if (!dragging) return;
      dragging = false;
      suppressNext = true;
      if (cancel){ snapTo(curIdx); return; }
      var idx = nearestIdx(Math.max(0, Math.min(barW, e.clientX - barLeft)));
      commit(idx);
    }
    bar.addEventListener("pointerup", function(e){ endDrag(e, false); });
    bar.addEventListener("pointercancel", function(e){ endDrag(e, true); });

    /* re-sync when beauty-bottom-sheet.js swaps the buttons */
    if (window.MutationObserver){
      new MutationObserver(function(){
        wrapLabels();
        measure();
        snapTo(curIdx, true);
        queueDockContrast(false);
      }).observe(bar, { childList: true });
    }

    /* scroll-minimise (bn-min) removed 5 Jul 2026 per T — the shrink/restore
       cycle while scrolling read as a glitch. Bar now keeps a constant height. */

    window.addEventListener("resize", function(){
      if (!activeDock()) return;
      applyDockSkin();
      measure(); snapTo(curIdx, true);
      queueDockContrast(false);
    });

    function onDockSurfaceChange(){ queueDockContrast(false); }
    try{
      document.addEventListener("scroll", onDockSurfaceChange, { passive:true, capture:true });
    }catch(e){
      document.addEventListener("scroll", onDockSurfaceChange, true);
    }
    window.addEventListener("orientationchange", onDockSurfaceChange);
    document.addEventListener("load", function(e){
      var tag = e.target && e.target.tagName;
      if (tag === "IMG" || tag === "VIDEO") queueDockContrast(false);
    }, true);

    /* inline dock hardening — beats any stylesheet conflict */
    function applyDockSkin(){
      if (window.innerWidth > 991){
        bar.style.cssText = bar.style.cssText
          .replace(/left:[^;]+;?|right:[^;]+;?|bottom:[^;]+;?|border-radius:[^;]+;?/g, "");
        return;
      }
      var s = bar.style;
      s.left = "0"; s.right = "0"; s.bottom = "0";
      s.height = "calc(66px + env(safe-area-inset-bottom, 0px))";
      s.boxSizing = "border-box";
      s.alignItems = "flex-start";
      s.borderRadius = "0";
      s.background = "transparent";
      s.webkitBackdropFilter = "none";
      s.backdropFilter = "none";
      s.border = "0";
      s.borderTop = "0";
      s.boxShadow = "none";
      s.padding = "2px 12px env(safe-area-inset-bottom, 0px)";
      s.overflow = "visible";
    }

    /* Native parity: exact destination, otherwise shopping context, never stale Exclusive. */
    function initialIdx(){
      try{
        for (var i = 0; i < items.length; i++){
          if (items[i].tagName === "A" && items[i].href){
            var u = new URL(items[i].href, location.origin);
            if (u.pathname === location.pathname) return i;
          }
        }
      }catch(e){}
      if (location.pathname.indexOf('/collections/') === 0 || location.pathname.indexOf('/search') === 0) return items.findIndex(function(el){return el.id === 'shopBtn1';});
      return 0;
    }

    /* boot AFTER the sheet engine's clone pass (it runs at
       DOMContentLoaded / +100ms) — 350ms covers it, then the
       MutationObserver covers anything later */
    var bootTries = 0;
    function boot(){
      /* bar stays hidden on desktop (min-width:992px) — stop polling after ~10s
         instead of retrying forever */
      if (!visible()){ if (++bootTries < 40) setTimeout(boot, 250); return; }
      wrapLabels();
      applyDockSkin();
      measure();
      snapTo(initialIdx(), true);
      queueDockContrast(true);
    }
    setTimeout(boot, 350);
    }

    initDock(document.querySelector(".bottom-nav"));
    document.addEventListener("shopify:section:load", function(e){
      if (!e.target) return;
      var nextTabs = e.target.matches && e.target.matches(".tabs-wrapper")
        ? e.target
        : e.target.querySelector && e.target.querySelector(".tabs-wrapper");
      if (nextTabs) initTabs(nextTabs);
      var nextBar = e.target.matches && e.target.matches(".bottom-nav")
        ? e.target
        : e.target.querySelector && e.target.querySelector(".bottom-nav");
      if (nextBar) initDock(nextBar);
      initScrollRails();
    });
    document.addEventListener("shopify:section:unload", function(){
      window.setTimeout(initScrollRails, 0);
    });
    document.addEventListener("shopify:section:reorder", function(){
      window.setTimeout(initScrollRails, 0);
    });
  });

  /* Cart controls boot independently after the navigation engine. A cart
     failure must never prevent adaptive top/dock contrast from starting. */
  ready(function(){
    try{
      /* ---- product-card cart control: the compact CTA becomes a native-feeling
         quantity stepper after a successful add. Keep Shopify's quick-add and
         variant picker for the first add; use the Ajax Cart API only for +/-.
         Single-value option groups (for example Size: 500ml) are hidden because
         they are not choices. Real multi-value groups remain selectable. ---- */
      (function initCardQuantityControls(){
        var activeSlot = null;
        var cartRequest = null;
        var cartForceRequest = null;
        var cartState = null;
        var cartMutationQueue = Promise.resolve();
        var directAddOrigins = {};
        var cartBubbleObserver = null;
        var observedCartBubble = null;
        var cartToastTimer = null;
        var cartRefreshTimer = null;
        var cartRefreshMustForce = false;
        var cartModalDirty = false;
        var cartOptimisticBaseCount = null;
        var internalCartCountUntil = 0;
        var modal = document.getElementById("quick-add-modal");
        var productInfo = modal && modal.querySelector("[data-product-info-container]");
        var dialog = modal && modal.querySelector('[role="dialog"]');
        var defaultDialogLabel = dialog && dialog.getAttribute("aria-label");
  
        function cardSlots(){
          return Array.prototype.slice.call(document.querySelectorAll("[data-bui-card-cart]"));
        }
  
        function profileLabel(button){
          if (!button) return "Profile";
          var saved = button.getAttribute("data-bui-profile-label");
          if (saved) return saved;
          var spans = button.querySelectorAll(":scope > span");
          var label = spans.length ? spans[spans.length - 1].textContent : button.textContent;
          label = (label || "Profile").replace(/\s+/g, " ").trim() || "Profile";
          button.setAttribute("data-bui-profile-label", label);
          return label;
        }

        function updateProfileCartCount(count){
          var button = document.getElementById("shopBtn3");
          var quantity = Math.max(0, parseInt(count, 10) || 0);
          var visualCount = String(quantity);
          if (button){button.removeAttribute("data-bui-cart-count");button.setAttribute("aria-label","Profile");}
          document.querySelectorAll('[data-native-cart-count]').forEach(function(el){el.textContent=visualCount;el.hidden=quantity===0;});
          var rows = document.querySelectorAll(".bot-profile-cart-row");
          for (var i = 0; i < rows.length; i++){
            if (quantity > 0){
              rows[i].setAttribute("data-bui-cart-count", visualCount);
              rows[i].setAttribute("aria-label", "Cart. " + quantity + (quantity === 1 ? " item" : " items") + ".");
            } else {
              rows[i].removeAttribute("data-bui-cart-count");
              rows[i].setAttribute("aria-label", "Cart");
            }
          }
        }

        function readCanonicalCartCount(){
          var bubble = document.getElementById("CartBubble");
          if (!bubble || bubble.classList.contains("hidden")) return 0;
          return Math.max(0, parseInt((bubble.textContent || "").replace(/[^0-9]/g, ""), 10) || 0);
        }

        function setCartCount(count){
          var quantity = Math.max(0, parseInt(count, 10) || 0);
          internalCartCountUntil = Date.now() + 160;
          var badges = document.querySelectorAll("#CartBubble, #BotMobileCartCount");
          for (var i = 0; i < badges.length; i++){
            if (quantity > 0){
              badges[i].classList.remove("hidden");
              badges[i].textContent = String(quantity);
            } else {
              badges[i].classList.add("hidden");
              badges[i].textContent = "";
            }
          }
          updateProfileCartCount(quantity);
          return quantity;
        }

        function hasPendingCartMutation(){
          var slots = cardSlots();
          for (var i = 0; i < slots.length; i++){
            if (slots[i].__buiQuantityPending || slots[i].__buiFlushTimer) return true;
          }
          return false;
        }

        function scheduleCartRefresh(forceEvenIfCountMatches){
          cartRefreshMustForce = cartRefreshMustForce || forceEvenIfCountMatches === true;
          if (cartRefreshTimer) window.clearTimeout(cartRefreshTimer);
          cartRefreshTimer = window.setTimeout(function refreshWhenIdle(){
            if (hasPendingCartMutation()){
              cartRefreshTimer = window.setTimeout(refreshWhenIdle, 120);
              return;
            }
            cartRefreshTimer = null;
            var mustForce = cartRefreshMustForce;
            cartRefreshMustForce = false;
            var canonicalCount = readCanonicalCartCount();
            if (!mustForce && cartState && canonicalCount === cartState.item_count) return;
            if (!mustForce && cartRequest){
              cartRequest.catch(function(){ return null; }).then(function(){
                if (!cartState || readCanonicalCartCount() !== cartState.item_count) scheduleCartRefresh(false);
              });
              return;
            }
            fetchCart(true).catch(function(error){ console.error(error); });
          }, 80);
        }

        function reloadDirtyCartModal(){
          if (!cartModalDirty || !cartModal || typeof cartModal.reloadContent !== "function") return;
          cartModalDirty = false;
          Promise.resolve(cartModal.reloadContent()).catch(function(error){
            cartModalDirty = true;
            console.error(error);
          });
        }

        function setCartBubble(html){
          if (html == null) return;
          var match = html.match(/\d+/);
          setCartCount(match ? parseInt(match[0], 10) : 0);
        }

        function observeCanonicalCartCount(){
          var bubble = document.getElementById("CartBubble");
          if (!bubble || !window.MutationObserver) return;
          if (observedCartBubble === bubble) return;
          if (cartBubbleObserver) cartBubbleObserver.disconnect();
          observedCartBubble = bubble;
          cartBubbleObserver = new MutationObserver(function(){
            var count = readCanonicalCartCount();
            updateProfileCartCount(count);
            if (Date.now() < internalCartCountUntil) return;
            if (cartState && count === cartState.item_count) return;
            scheduleCartRefresh(false);
          });
          cartBubbleObserver.observe(bubble, {
            childList:true,
            characterData:true,
            subtree:true,
            attributes:true,
            attributeFilter:["class"]
          });
          updateProfileCartCount(readCanonicalCartCount());
        }

        function showProfileCartToast(count){
          var quantity = Math.max(0, parseInt(count, 10) || 0);
          if (!quantity) return;
          var toast = document.querySelector("[data-bui-cart-toast]");
          if (!toast){
            toast = document.createElement("div");
            toast.className = "bui-cart-toast";
            toast.setAttribute("data-bui-cart-toast", "");
            toast.setAttribute("aria-hidden", "true");
            document.body.appendChild(toast);
          }
          var profile = document.getElementById("shopBtn3");
          if (profile){
            var rect = profile.getBoundingClientRect();
            if (rect.width) toast.style.setProperty("--bui-cart-toast-x", (rect.left + rect.width / 2) + "px");
          }
          toast.textContent = "Added to cart \u00b7 " + quantity + (quantity === 1 ? " item" : " items");
          toast.classList.remove("bui-cart-toast--visible");
          void toast.offsetWidth;
          toast.classList.add("bui-cart-toast--visible");
          if (cartToastTimer) window.clearTimeout(cartToastTimer);
          cartToastTimer = window.setTimeout(function(){
            toast.classList.remove("bui-cart-toast--visible");
          }, 1800);
        }

        function rememberDirectAddOrigin(variantId, slot){
          if (!variantId || !slot) return;
          var key = String(variantId);
          var entry = { slot:slot, timer:null };
          if (!directAddOrigins[key]) directAddOrigins[key] = [];
          directAddOrigins[key].push(entry);
          entry.timer = window.setTimeout(function(){
            var queue = directAddOrigins[key] || [];
            var index = queue.indexOf(entry);
            if (index !== -1) queue.splice(index, 1);
            if (!queue.length) delete directAddOrigins[key];
          }, 15000);
        }

        function takeDirectAddOrigin(variantId){
          var key = String(variantId);
          var queue = directAddOrigins[key];
          if (!queue || !queue.length) return null;
          var entry = queue.shift();
          if (entry.timer) window.clearTimeout(entry.timer);
          if (!queue.length) delete directAddOrigins[key];
          return entry.slot && document.documentElement.contains(entry.slot) ? entry.slot : null;
        }
  
        function cartQuantity(cart, variantId){
          var quantity = 0;
          if (!cart || !cart.items || !variantId) return quantity;
          for (var i = 0; i < cart.items.length; i++){
            if (String(cart.items[i].variant_id) === String(variantId)) quantity += cart.items[i].quantity;
          }
          return quantity;
        }

        function displayedCartCount(cart){
          var count = cart && cart.item_count != null ? cart.item_count : 0;
          var seen = {};
          var slots = cardSlots();
          for (var i = 0; i < slots.length; i++){
            var variantId = slots[i].getAttribute("data-bui-variant-id");
            if (!variantId || seen[variantId] || slots[i].__buiDesiredQuantity == null) continue;
            if (!slots[i].__buiQuantityPending && !slots[i].__buiFlushTimer) continue;
            seen[variantId] = true;
            var displayedQuantity = Math.max(
              0,
              parseInt(slots[i].getAttribute("data-bui-cart-quantity"), 10) || 0
            );
            count += displayedQuantity - cartQuantity(cart, variantId);
          }
          return Math.max(0, count);
        }
  
        function matchingLines(cart, variantId){
          var lines = [];
          if (!cart || !cart.items || !variantId) return lines;
          for (var i = 0; i < cart.items.length; i++){
            if (String(cart.items[i].variant_id) === String(variantId)) lines.push(cart.items[i]);
          }
          return lines;
        }

        function preferredLine(cart, variantId, lineKey){
          var lines = matchingLines(cart, variantId);
          if (lines.length !== 1) return null;
          if (lineKey){
            for (var i = 0; i < lines.length; i++){
              if (String(lines[i].key) === String(lineKey)) return lines[i];
            }
          }
          return lines[0];
        }

        function setSlotQuantity(slot, quantity, optimistic){
          if (!slot) return;
          quantity = Math.max(0, parseInt(quantity, 10) || 0);
          var quickAdd = slot.querySelector("quick-add-button");
          var control = slot.querySelector("[data-bui-quantity-control]");
          var viewCart = slot.querySelector("[data-bui-view-cart]");
          var value = slot.querySelector("[data-bui-quantity-value]");
          var focusWasInQuickAdd = quickAdd && quickAdd.contains(document.activeElement);
          var focusWasInControl = control && control.contains(document.activeElement);
          slot.setAttribute("data-bui-cart-quantity", String(quantity));
          slot.removeAttribute("data-bui-ambiguous-cart");
          if (viewCart) viewCart.hidden = true;
          if (value) value.textContent = String(quantity);
  
          if (quantity > 0){
            if (quickAdd) quickAdd.hidden = true;
            if (control) control.hidden = false;
            if (focusWasInQuickAdd && control){
              var increase = control.querySelector("[data-bui-quantity-increase]");
              if (increase) window.setTimeout(function(){ increase.focus(); }, 0);
            }
          } else if (optimistic){
            if (quickAdd) quickAdd.hidden = true;
            if (control) control.hidden = false;
          } else {
            if (control) control.hidden = true;
            if (quickAdd) quickAdd.hidden = false;
            if (slot.getAttribute("data-bui-requires-selection") === "true"){
              slot.removeAttribute("data-bui-variant-id");
              if (quickAdd) quickAdd.removeAttribute("variant-id");
            }
            if (focusWasInControl && quickAdd){
              var quickAddButton = quickAdd.querySelector("button");
              if (quickAddButton) window.setTimeout(function(){ quickAddButton.focus(); }, 0);
            }
          }
        }

        function setSlotViewCart(slot, quantity){
          if (!slot) return;
          quantity = Math.max(0, parseInt(quantity, 10) || 0);
          var quickAdd = slot.querySelector("quick-add-button");
          var control = slot.querySelector("[data-bui-quantity-control]");
          var viewCart = slot.querySelector("[data-bui-view-cart]");
          var value = slot.querySelector("[data-bui-quantity-value]");
          slot.setAttribute("data-bui-cart-quantity", String(quantity));
          slot.setAttribute("data-bui-ambiguous-cart", "true");
          slot.removeAttribute("data-bui-line-key");
          if (value) value.textContent = String(quantity);
          if (quickAdd) quickAdd.hidden = true;
          if (control) control.hidden = true;
          if (viewCart){
            viewCart.hidden = false;
            viewCart.textContent = "View cart \u00b7 " + quantity;
            viewCart.setAttribute("aria-label", "View cart. " + quantity + (quantity === 1 ? " item" : " items") + " for this product.");
          }
        }
  
        function applyCart(cart){
          if (!cart || !cart.items) return cart;
          cartState = cart;
          var slots = cardSlots();
          for (var i = 0; i < slots.length; i++){
            var variantId = slots[i].getAttribute("data-bui-variant-id");
            if (!variantId) continue;
            var lines = matchingLines(cart, variantId);
            if (lines.length > 1){
              slots[i].__buiServerQuantity = cartQuantity(cart, variantId);
              setSlotViewCart(slots[i], slots[i].__buiServerQuantity);
              continue;
            }
            var line = preferredLine(cart, variantId, slots[i].getAttribute("data-bui-line-key"));
            if (line) slots[i].setAttribute("data-bui-line-key", String(line.key));
            else slots[i].removeAttribute("data-bui-line-key");
            slots[i].__buiServerQuantity = cartQuantity(cart, variantId);
            if (slots[i].__buiQuantityPending || slots[i].__buiFlushTimer) continue;
            slots[i].__buiDesiredQuantity = null;
            slots[i].__buiConfirmedQuantity = null;
            slots[i].__buiConfirmedCartCount = null;
            setSlotQuantity(slots[i], slots[i].__buiServerQuantity, false);
          }
          setCartCount(displayedCartCount(cart));
          if (!hasPendingCartMutation()) cartOptimisticBaseCount = null;
          return cart;
        }

        function fetchCart(force){
          if (force && cartRequest){
            if (cartForceRequest) return cartForceRequest;
            cartForceRequest = cartRequest.catch(function(){ return null; }).then(function(){
              cartForceRequest = null;
              return fetchCart(true);
            });
            return cartForceRequest;
          }
          if (cartRequest) return cartRequest;
          if (!force && cartState) return Promise.resolve(cartState);
          var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
          cartRequest = fetch(root + "cart.js", { headers:{ Accept:"application/json" } })
            .then(function(response){
              if (!response.ok) throw new Error("Unable to read cart");
              return response.json();
            })
            .then(applyCart)
            .finally(function(){ cartRequest = null; });
          return cartRequest;
        }
  
        function setBusy(slot, busy){
          var control = slot && slot.querySelector("[data-bui-quantity-control]");
          if (control) control.setAttribute("aria-busy", busy ? "true" : "false");
        }

        function pendingCartCountWithoutState(fallbackCount){
          var count = cartOptimisticBaseCount == null ? fallbackCount : cartOptimisticBaseCount;
          var seen = {};
          var slots = cardSlots();
          count = Math.max(0, parseInt(count, 10) || 0);
          for (var i = 0; i < slots.length; i++){
            var variantId = slots[i].getAttribute("data-bui-variant-id");
            if (!variantId || seen[variantId] || slots[i].__buiDesiredQuantity == null ||
                (!slots[i].__buiQuantityPending && !slots[i].__buiFlushTimer)) continue;
            seen[variantId] = true;
            var confirmedQuantity = Math.max(0, parseInt(slots[i].__buiConfirmedQuantity, 10) || 0);
            var displayedQuantity = Math.max(
              0,
              parseInt(slots[i].getAttribute("data-bui-cart-quantity"), 10) || 0
            );
            count += displayedQuantity - confirmedQuantity;
          }
          return Math.max(0, count);
        }

        function restoreVariantSlots(variantId, activeSlot, fallbackQuantity){
          var slots = cardSlots();
          for (var i = 0; i < slots.length; i++){
            if (slots[i].getAttribute("data-bui-ambiguous-cart") === "true" ||
                String(slots[i].getAttribute("data-bui-variant-id")) !== String(variantId) ||
                slots[i].__buiQuantityPending || slots[i].__buiFlushTimer) continue;
            var confirmedQuantity = slots[i].__buiConfirmedQuantity;
            if (confirmedQuantity == null && slots[i] === activeSlot) confirmedQuantity = fallbackQuantity;
            if (confirmedQuantity != null) setSlotQuantity(slots[i], confirmedQuantity, false);
            slots[i].__buiDesiredQuantity = null;
            slots[i].__buiConfirmedQuantity = null;
            slots[i].__buiConfirmedCartCount = null;
            setBusy(slots[i], false);
          }
        }
  
        function announce(slot, text){
          var status = slot && slot.querySelector("[data-bui-quantity-status]");
          if (!status) return;
          status.textContent = "";
          window.setTimeout(function(){ status.textContent = text; }, 20);
        }
  
        function postCart(url, body){
          return fetch(url, {
            method:"POST",
            headers:{
              Accept:"application/json",
              "Content-Type":"application/json",
              "X-Requested-With":"XMLHttpRequest"
            },
            body:JSON.stringify(body)
          }).then(function(response){
            return response.json().then(function(payload){
              if (!response.ok || payload.status) throw new Error(payload.description || payload.message || "Unable to update cart");
              return payload;
            });
          });
        }

        function runQuantityMutation(slot){
          var variantId = slot && slot.getAttribute("data-bui-variant-id");
          var sentQuantity = slot && slot.__buiDesiredQuantity;
          var serverQuantityBefore = 0;
          if (!variantId || sentQuantity == null){
            if (slot){
              slot.__buiQuantityPending = false;
              setBusy(slot, false);
              if (cartState) applyCart(cartState);
              else if (slot.__buiConfirmedCartCount != null) setCartCount(slot.__buiConfirmedCartCount);
              slot.__buiConfirmedCartCount = null;
              slot.__buiConfirmedQuantity = null;
            }
            return Promise.resolve();
          }

          return fetchCart(false).then(function(cart){
            serverQuantityBefore = cartQuantity(cart, variantId);
            if (sentQuantity === serverQuantityBefore) return cart;
            var line = preferredLine(cart, variantId, slot.getAttribute("data-bui-line-key"));
            var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
            if (serverQuantityBefore > 0 && !line){
              throw new Error("Open the cart to change this item because it has multiple cart lines.");
            }
            if (line){
              return postCart((window.routes && window.routes.cart_change_url) || root + "cart/change.js", {
                id:line.key,
                quantity:sentQuantity,
                sections:["cart-bubble"],
                sections_url:window.location.pathname
              });
            }
            if (sentQuantity < 1) return cart;
            return postCart((window.routes && window.routes.cart_add_url) || root + "cart/add.js", {
              id:variantId,
              quantity:sentQuantity,
              sections:["cart-bubble"],
              sections_url:root + "variants/" + variantId
            }).then(function(){ return fetchCart(true); });
          }).then(function(cart){
            if (!cart) return;
            if (cart.sections && cart.sections["cart-bubble"] != null) setCartBubble(cart.sections["cart-bubble"]);
            cartState = cart;
            var actualQuantity = cartQuantity(cart, variantId);
            var addedQuantity = Math.max(0, actualQuantity - serverQuantityBefore);
            var latestQuantity = slot.__buiDesiredQuantity;
            var stable = latestQuantity === sentQuantity;

            if (stable){
              slot.__buiDesiredQuantity = null;
              slot.__buiConfirmedCartCount = null;
              slot.__buiConfirmedQuantity = null;
              slot.__buiQuantityPending = false;
              setBusy(slot, false);
              applyCart(cart);
              var title = slot.getAttribute("data-bui-product-title") || "Product";
              announce(slot, title + ". Quantity " + actualQuantity + " in cart.");
              if (addedQuantity > 0){
                document.dispatchEvent(new CustomEvent("product:added-to-cart", {
                  detail:{ id:variantId, quantity:addedQuantity, buiQuantityControl:true, cart:cart }
                }));
              } else if (actualQuantity !== serverQuantityBefore){
                cartModalDirty = true;
                if (cartModal && cartModal.open) reloadDirtyCartModal();
              }
            } else {
              applyCart(cart);
              slot.__buiQuantityPending = false;
              setSlotQuantity(slot, latestQuantity, true);
              setCartCount(cart.item_count + latestQuantity - actualQuantity);
              if (slot.__buiFlushTimer) window.clearTimeout(slot.__buiFlushTimer);
              slot.__buiFlushTimer = window.setTimeout(function(){
                slot.__buiFlushTimer = null;
                flushQuantity(slot);
              }, 0);
            }
          }).catch(function(error){
            console.error(error);
            slot.__buiDesiredQuantity = null;
            slot.__buiQuantityPending = false;
            if (slot.__buiFlushTimer){
              window.clearTimeout(slot.__buiFlushTimer);
              slot.__buiFlushTimer = null;
            }
            setBusy(slot, false);
            if (cartState) applyCart(cartState);
            else {
              var confirmedCartCount = slot.__buiConfirmedCartCount;
              restoreVariantSlots(
                variantId,
                slot,
                slot.__buiConfirmedQuantity == null ? serverQuantityBefore : slot.__buiConfirmedQuantity
              );
              setCartCount(pendingCartCountWithoutState(
                confirmedCartCount == null ? readCanonicalCartCount() : confirmedCartCount
              ));
            }
            slot.__buiConfirmedCartCount = null;
            slot.__buiConfirmedQuantity = null;
            if (!hasPendingCartMutation()) cartOptimisticBaseCount = null;
            announce(slot, error && error.message ? error.message : "Unable to update cart.");
            scheduleCartRefresh(true);
          });
        }

        function flushQuantity(slot){
          var variantId = slot && slot.getAttribute("data-bui-variant-id");
          if (!variantId || slot.__buiQuantityPending || slot.__buiDesiredQuantity == null) return;
          slot.__buiQuantityPending = true;
          setBusy(slot, true);
          cartMutationQueue = cartMutationQueue.catch(function(){ return null; }).then(function(){
            return runQuantityMutation(slot);
          });
        }

        function mutateQuantity(slot, delta){
          var variantId = slot && slot.getAttribute("data-bui-variant-id");
          if (!variantId) return;
          var currentQuantity = Math.max(0, parseInt(slot.getAttribute("data-bui-cart-quantity"), 10) || 0);
          var nextQuantity = Math.max(0, currentQuantity + delta);
          if (nextQuantity === currentQuantity) return;
          if (cartOptimisticBaseCount == null){
            cartOptimisticBaseCount = cartState && cartState.item_count != null
              ? cartState.item_count
              : readCanonicalCartCount();
          }
          if (slot.__buiConfirmedCartCount == null){
            slot.__buiConfirmedCartCount = cartOptimisticBaseCount;
          }
          if (slot.__buiConfirmedQuantity == null) slot.__buiConfirmedQuantity = currentQuantity;
          slot.__buiDesiredQuantity = nextQuantity;
          setSlotQuantity(slot, nextQuantity, true);
          var matchingSlots = cardSlots();
          for (var i = 0; i < matchingSlots.length; i++){
            if (matchingSlots[i] === slot ||
                matchingSlots[i].getAttribute("data-bui-ambiguous-cart") === "true" ||
                String(matchingSlots[i].getAttribute("data-bui-variant-id")) !== String(variantId)) continue;
            if (matchingSlots[i].__buiConfirmedQuantity == null){
              matchingSlots[i].__buiConfirmedQuantity = Math.max(
                0,
                parseInt(matchingSlots[i].getAttribute("data-bui-cart-quantity"), 10) || 0
              );
            }
            if (matchingSlots[i].__buiConfirmedCartCount == null){
              matchingSlots[i].__buiConfirmedCartCount = slot.__buiConfirmedCartCount;
            }
            if (matchingSlots[i].__buiQuantityPending || matchingSlots[i].__buiFlushTimer){
              matchingSlots[i].__buiDesiredQuantity = nextQuantity;
            }
            setSlotQuantity(matchingSlots[i], nextQuantity, true);
          }
          setBusy(slot, true);
          setCartCount(Math.max(0, readCanonicalCartCount() + nextQuantity - currentQuantity));
          if (slot.__buiFlushTimer) window.clearTimeout(slot.__buiFlushTimer);
          slot.__buiFlushTimer = window.setTimeout(function(){
            slot.__buiFlushTimer = null;
            flushQuantity(slot);
          }, 90);
        }
  
        function optionValues(group){
          var inputs = group.querySelectorAll("[data-option-value-id], input[type=radio], option");
          var values = {};
          for (var i = 0; i < inputs.length; i++){
            var value = inputs[i].getAttribute("data-option-value-id") ||
              inputs[i].getAttribute("data-value") || inputs[i].value;
            if (value) values[value] = true;
          }
          return Object.keys(values);
        }
  
        function refineVariantOptions(){
          if (!modal || !productInfo || !productInfo.firstElementChild) return;
          var groups = productInfo.querySelectorAll("[data-option-group]");
          var fragranceMode = activeSlot && activeSlot.getAttribute("data-bui-fragrance-options") === "true";
          var visibleGroups = 0;
  
          for (var i = 0; i < groups.length; i++){
            var wrapper = groups[i].closest && groups[i].closest(".mb-6");
            var displayGroup = groups[i].tagName === "DROPDOWN-LIST" && wrapper ? wrapper : groups[i];
            var legend = (wrapper || groups[i]).querySelector("legend, .label-product-info");
            var name = groups[i].getAttribute("list-title") || (legend ? legend.textContent : "");
            name = name.trim().toLowerCase();
            var single = optionValues(groups[i]).length <= 1;
            if (displayGroup !== groups[i]){
              groups[i].classList.remove("bui-single-option-hidden", "bui-fragrance-option");
            }
            displayGroup.classList.toggle("bui-single-option-hidden", single);
            displayGroup.classList.toggle("bui-fragrance-option", name.indexOf("fragrance") !== -1);
            if (!single) visibleGroups++;
          }
  
          if (fragranceMode){
            if (dialog) dialog.setAttribute("aria-label", "Choose fragrance");
            modal.classList.add("bui-fragrance-quick-add");
          } else {
            if (dialog) dialog.setAttribute("aria-label", defaultDialogLabel || "Select options");
            modal.classList.remove("bui-fragrance-quick-add");
          }
          modal.setAttribute("data-bui-visible-option-groups", String(visibleGroups));
        }
  
        document.addEventListener("click", function(event){
          var quickAdd = event.target.closest && event.target.closest("quick-add-button.bot-card-quick-add");
          if (quickAdd){
            var clickedSlot = quickAdd.closest("[data-bui-card-cart]");
            var directVariantId = quickAdd.getAttribute("variant-id");
            if (clickedSlot && directVariantId && clickedSlot.getAttribute("data-bui-requires-selection") !== "true"){
              rememberDirectAddOrigin(directVariantId, clickedSlot);
              return;
            }
            activeSlot = clickedSlot;
            window.setTimeout(refineVariantOptions, 0);
            window.setTimeout(refineVariantOptions, 180);
            return;
          }
  
          var increase = event.target.closest && event.target.closest("[data-bui-quantity-increase]");
          if (increase){
            event.preventDefault();
            mutateQuantity(increase.closest("[data-bui-card-cart]"), 1);
            return;
          }
  
          var decrease = event.target.closest && event.target.closest("[data-bui-quantity-decrease]");
          if (decrease){
            event.preventDefault();
            mutateQuantity(decrease.closest("[data-bui-card-cart]"), -1);
          }
        }, true);

        document.addEventListener("change", function(event){
          var swatch = event.target;
          if (!swatch || !swatch.matches ||
              !swatch.matches("product-card-swatches [data-variant-id]:checked")) return;
          var card = swatch.closest && swatch.closest(".product-card");
          var slot = card && card.querySelector("[data-bui-card-cart]");
          if (!slot || slot.getAttribute("data-bui-requires-selection") !== "true") return;
          if (activeSlot === slot) activeSlot = null;
          if (!slot.__buiQuantityPending){
            if (slot.__buiFlushTimer) window.clearTimeout(slot.__buiFlushTimer);
            slot.__buiFlushTimer = null;
            slot.__buiDesiredQuantity = null;
            slot.__buiConfirmedQuantity = null;
            slot.__buiConfirmedCartCount = null;
            setBusy(slot, false);
            setCartCount(cartState ? cartState.item_count : readCanonicalCartCount());
          }
          slot.removeAttribute("data-bui-line-key");
          setSlotQuantity(slot, 0, false);
        });

        document.addEventListener("product:added-to-cart", function(event){
          var detail = event.detail || {};
          var variantId = detail.id;
          if (!variantId) return;
          cartModalDirty = false;

          if (detail.buiQuantityControl === true){
            if (detail.cart && detail.cart.item_count != null){
              cartState = detail.cart;
              setCartCount(detail.cart.item_count);
              showProfileCartToast(detail.cart.item_count);
            }
            return;
          }

          var addedSlot = takeDirectAddOrigin(variantId);
          if (!addedSlot && activeSlot &&
              activeSlot.getAttribute("data-bui-requires-selection") === "true" &&
              document.documentElement.contains(activeSlot)){
            addedSlot = activeSlot;
          }
          var showToast = addedSlot && addedSlot.getAttribute("data-bui-requires-selection") === "true";
          if (addedSlot){
            addedSlot.setAttribute("data-bui-variant-id", String(variantId));
            var quickAdd = addedSlot.querySelector("quick-add-button");
            if (quickAdd) quickAdd.setAttribute("variant-id", String(variantId));
            var addedQuantity = Math.max(1, parseInt(detail.quantity, 10) || 1);
            var currentQuantity = Math.max(0, parseInt(addedSlot.getAttribute("data-bui-cart-quantity"), 10) || 0);
            setSlotQuantity(addedSlot, currentQuantity + addedQuantity, false);
          }

          window.setTimeout(function(){
            var count = readCanonicalCartCount();
            updateProfileCartCount(count);
            if (showToast) showProfileCartToast(count);
            scheduleCartRefresh(true);
          }, 0);
          if (activeSlot === addedSlot) activeSlot = null;
        });
  
        if (modal){
          modal.addEventListener("hide", function(){
            activeSlot = null;
            modal.classList.remove("bui-fragrance-quick-add");
            if (dialog) dialog.setAttribute("aria-label", defaultDialogLabel || "Select options");
          });
        }
  
        if (productInfo && window.MutationObserver){
          new MutationObserver(refineVariantOptions).observe(productInfo, { childList:true, subtree:true });
        }

        var cartModal = document.querySelector("cart-modal");
        if (cartModal){
          cartModal.addEventListener("show", reloadDirtyCartModal);
          cartModal.addEventListener("hide-end", function(){ scheduleCartRefresh(true); });
        }
        window.addEventListener("pageshow", function(event){
          if (event.persisted) scheduleCartRefresh(true);
        });
  
        document.addEventListener("shopify:section:load", function(){
          observeCanonicalCartCount();
          if (cartState) applyCart(cartState);
          else fetchCart(false).catch(function(error){ console.error(error); });
        });
        observeCanonicalCartCount();
        fetchCart(false).catch(function(error){ console.error(error); });
      })();
    }catch(error){
      console.error(error);
    }
  });
})();
